var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "campana",
    transform: "translate(-1230 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_14",
    "data-name": "Tracciato 14",
    d: "M157.48,419.375a2.815,2.815,0,0,1-2.812-2.812.563.563,0,1,1,1.125,0,1.688,1.688,0,0,0,3.375,0,.563.563,0,1,1,1.125,0A2.815,2.815,0,0,1,157.48,419.375Zm0,0",
    transform: "translate(1080.02 -386.375)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_15",
    "data-name": "Tracciato 15",
    d: "M35.02,77.5H22.645a1.313,1.313,0,0,1-.854-2.31,5.026,5.026,0,0,0,1.791-3.849V69.25a5.25,5.25,0,0,1,10.5,0v2.091a5.025,5.025,0,0,0,1.784,3.844A1.312,1.312,0,0,1,35.02,77.5ZM28.832,65.125a4.129,4.129,0,0,0-4.125,4.125v2.091a6.147,6.147,0,0,1-2.182,4.7.187.187,0,0,0-.068.144.19.19,0,0,0,.188.187H35.02a.19.19,0,0,0,.187-.187.185.185,0,0,0-.066-.143,6.149,6.149,0,0,1-2.184-4.7V69.25A4.129,4.129,0,0,0,28.832,65.125Zm0,0",
    transform: "translate(1208.668 -46.75)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16",
    "data-name": "Tracciato 16",
    d: "M219.231,3.375a.563.563,0,0,1-.562-.563V.563a.562.562,0,1,1,1.125,0v2.25A.563.563,0,0,1,219.231,3.375Zm0,0",
    transform: "translate(1018.27 15)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.a5635062d7249b662369197f8c68cbdb.svg";
export { ForwardRef as ReactComponent };